module.exports = __webpack_public_path__ + "img/lu.ad03efd0.svg";